import React, { FC } from 'react';
import {
  SystemButtonDefault,
  SystemButtonProps,
  SystemButtonContent,
} from '../SystemButton';
import styles from './text_button.module.scss';

export const TextButton: FC<SystemButtonProps> = ({
  children,
  onClick,
  iconLeft,
  iconRight,
  disabled,
  dataName,
  type,
  id,
}) => {
  const commonProps = {
    disabled,
    className: styles.text,
    name: dataName,
    id,
  };
  const content = <span className={styles.content}>{children}</span>;

  if (type === 'submit') {
    return (
      <button type="submit" {...commonProps}>
        <SystemButtonContent iconRight={iconRight} iconLeft={iconLeft}>
          {content}
        </SystemButtonContent>
      </button>
    );
  }

  return (
    <button type="button" onClick={onClick} {...commonProps}>
      <SystemButtonContent iconRight={iconRight} iconLeft={iconLeft}>
        {content}
      </SystemButtonContent>
    </button>
  );
};

TextButton.defaultProps = SystemButtonDefault;
